import React, { useState } from "react";
import { MdExpandMore, MdInfoOutline } from "react-icons/md";
import EAChip from "../shared/Chip/EAChip";

const SubaccountExplanation: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <aside className="subaccount-explanation">
      <div
        className="subaccount-explanation__header"
        onClick={() => setIsOpen((prev) => !prev)}
        role="button"
        aria-expanded={isOpen}
      >
        <MdInfoOutline className="subaccount-explanation__header-icon" />
        <h4 className="subaccount-explanation__title">Jak działa konto rodzica?</h4>
        <MdExpandMore
          className={`subaccount-explanation__toggle-icon${isOpen ? " subaccount-explanation__toggle-icon--open" : ""}`}
        />
      </div>

      <div className={`subaccount-explanation__body${isOpen ? " subaccount-explanation__body--visible" : ""}`}>
        <p className="subaccount-explanation__description">
         Jedno konto rodzica pozwala zarządzać wszystkimi dziećmi zapisanymi na zajęcia.
        </p>

        <div className="subaccount-explanation__chips">
          <EAChip label="1 KONTO → WIELE DZIECI" variant="success" />
          <EAChip label="KARNET DLA DZIECKA" variant="success" />
          <EAChip label="PŁATNOŚĆ ONLINE" variant="success" />
        </div>

        <p className="subaccount-explanation__list-label">W swoim koncie możesz:</p>
        <ul className="subaccount-explanation__list">
          <li className="subaccount-explanation__list-item">zarządzać wszystkimi dziećmi</li>
          <li className="subaccount-explanation__list-item">kupować kolejne karnety</li>
          <li className="subaccount-explanation__list-item">sprawdzać obecności i historię zajęć</li>
          <li className="subaccount-explanation__list-item">kontrolować płatności w jednym miejscu</li>


        </ul>
      </div>
    </aside>
  );
};

export default SubaccountExplanation;
